import { QTD_DEPENDENTES_ENUM, retornaLabelDoValorParentesco, validatorParentescoEmDuplicidade, verificaConflitoRegrasPaisPadastros } from '../helpers/funcoesPadroes';
import { comparaRegrasDepAtuaisComDepUpSell, validarCategoria, validarQuantidadeDep } from './funcoesAuxiliaresZCL';

export class CorrenteCadastroZCL {
    constructor(
        dependentes,
        valoresForm,
        parentesco,
        subGrupoSelecionadoUpSell
    ) {
        this.valoresForm = valoresForm;
        this.parentesco = parentesco;
        this.maximoDepSemValorAdicional = QTD_DEPENDENTES_ENUM.sete;
        this.arrayMsgsErro = [];
        this.subGrupoSelecionadoUpSell = subGrupoSelecionadoUpSell;

        if (subGrupoSelecionadoUpSell) {
            this.dependentes = dependentes.filter(dependente => dependente.Status === true);
        } else {
            this.dependentes = dependentes;
        }

        this.dependentesExistentes = this.dependentes?.length;
    }

    validarRegrasDepAtuaisComDepUpSell() {
        if (this.subGrupoSelecionadoUpSell) {
            const comparacaoDepAtualDepUpSell = comparaRegrasDepAtuaisComDepUpSell(this.dependentes, this.subGrupoSelecionadoUpSell);

            if (comparacaoDepAtualDepUpSell) {
                this.arrayMsgsErro = [
                    ...this.arrayMsgsErro,
                    comparacaoDepAtualDepUpSell
                ];
            }
        }

        return this;
    }

    quantidadeDependentesMaximo() {
        if (validarQuantidadeDep(this.valoresForm, this.dependentesExistentes)) {
            this.arrayMsgsErro.push(`Este plano permite no máximo ${QTD_DEPENDENTES_ENUM.dez} dependentes.`);
        }

        return this;
    }

    parentescoEmDuplicidade() {
        if (validatorParentescoEmDuplicidade(this.valoresForm, this.dependentes)) {
            this.arrayMsgsErro.push(`${retornaLabelDoValorParentesco(this.parentesco)}`);
        }

        return this;
    }

    validaSequenciaDependentes() {
        if (this.dependentesExistentes < this.maximoDepSemValorAdicional) {
            if (!['', 'ZELO'].includes(this.valoresForm.Categoria)) {
                const msgErro = `Você precisa adicionar ${this.maximoDepSemValorAdicional} dependentes sem valor adicional antes de adicionar dependente especial.`;

                this.arrayMsgsErro.push(
                    msgErro
                );
            }
        } else {
            if (this.dependentesExistentes >= this.maximoDepSemValorAdicional && this.valoresForm.Categoria === 'ZELO') {
                this.arrayMsgsErro.push('');
                this.arrayMsgsErro.push(
                    `Ao exceder ${this.maximoDepSemValorAdicional} dependentes sem custo adicional deverá ser selecionado categorias com custo adicional (ZCA64, ZCM65).`
                );
            } else {
                const resultValidarCategoria = validarCategoria(this.valoresForm);

                if (resultValidarCategoria.status) {
                    this.arrayMsgsErro.push(resultValidarCategoria.msg);
                }
            }
        }

        return this;
    }

    verificaRepeticaoPaisPadastros() {
        const parentesEmConflito = verificaConflitoRegrasPaisPadastros(this.dependentes, this.valoresForm);

        if (parentesEmConflito) {
            this.arrayMsgsErro.push(parentesEmConflito);
        }

        return this;
    }
}